import { Api } from '@monorepo/shared/apiClient';
import {
  FormTemplatesCacheEvents,
  formTemplatesCacheRegister,
} from '@monorepo/shared/cacheRegisters/forms/formTemplatesCacheRegister';
import { getQueryConfig } from '@monorepo/shared/utils/queryUtils';
import { FormTemplateRefResponse } from 'mapistry-shared';
import { queryCache, QueryConfig, useQuery } from 'react-query';

type UseFormTemplateListParams = Partial<Api.FetchFormTemplateListParams> & {
  config?: QueryConfig<FormTemplateRefResponse[], Api.ErrorResponse>;
};

type KeyParams = Api.FetchFormTemplateListParams;

const KEY_START = 'form-template-list';
export const createKey = ({ organizationId }: KeyParams) =>
  [KEY_START, organizationId] as const;

type Fetcher = Api.DataHookQueryFn<
  typeof createKey,
  typeof Api.fetchFormTemplateList
>;

const fetcher: Fetcher = (_, organizationId) =>
  Api.fetchFormTemplateList({ organizationId });

export const useFormTemplatesList = ({
  config: inputConfig,
  organizationId,
}: UseFormTemplateListParams) => {
  const isEnabled = !!organizationId;
  const config = getQueryConfig(inputConfig, isEnabled);
  const key = isEnabled ? createKey({ organizationId }) : undefined;
  const { data, ...queryInfo } = useQuery(key, fetcher, config);

  return {
    ...queryInfo,
    formTemplateList: data,
  };
};

export async function invalidateCache(): Promise<void> {
  await queryCache.invalidateQueries(KEY_START);
}

const cacheRegisterInvalidator = {
  hookName: 'useFormTemplatesList',
  callback: () => invalidateCache(),
};

formTemplatesCacheRegister(
  [FormTemplatesCacheEvents.CREATE, FormTemplatesCacheEvents.UPDATE],
  cacheRegisterInvalidator,
);
